import React from 'react';
import { useNavigate } from 'react-router-dom';
import SEO from '../components/SEO';

const TermsOfService = () => {
  const navigate = useNavigate();

  return (
    <div className="terms-of-service">
      <SEO
        title="Terms of Service | ART Aesthetics & Skincare"
        description="Review the terms of service for using the ART Aesthetics & Skincare website and services."
        path="/terms"
      />
      <button onClick={() => navigate('/')} className="back-button">← Back to Home</button>
      <div className="privacy-container">
        <h1>Terms of Service</h1>
        <p><strong>Last Updated: {new Date().getFullYear()}</strong></p>
        
        <section>
          <h2>1. Agreement to Terms</h2>
          <p>By accessing and using this website, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.</p>
        </section>

        <section>
          <h2>2. Use License</h2>
          <p>Permission is granted to temporarily download one copy of the materials (information or software) on Art Aesthetics' website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:</p>
          <ul>
            <li>Modify or copy the materials</li>
            <li>Use the materials for any commercial purpose or for any public display</li>
            <li>Attempt to decompile or reverse engineer any software contained on the website</li>
            <li>Remove any copyright or other proprietary notations from the materials</li>
            <li>Transfer the materials to another person or "mirror" the materials on any other server</li>
            <li>Use the website in any way that infringes upon the rights of others or restricts or inhibits the use and enjoyment of the website by any third party</li>
          </ul>
        </section>

        <section>
          <h2>3. Disclaimer</h2>
          <p>The materials on Art Aesthetics' website are provided on an 'as is' basis. Art Aesthetics makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.</p>
        </section>

        <section>
          <h2>4. Limitations</h2>
          <p>In no event shall Art Aesthetics or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on the website, even if Art Aesthetics or an authorized representative has been notified orally or in writing of the possibility of such damage.</p>
        </section>

        <section>
          <h2>5. Accuracy of Materials</h2>
          <p>The materials appearing on Art Aesthetics' website could include technical, typographical, or photographic errors. Art Aesthetics does not warrant that any of the materials on its website are accurate, complete, or current. Art Aesthetics may make changes to the materials contained on its website at any time without notice.</p>
        </section>

        <section>
          <h2>6. Links</h2>
          <p>Art Aesthetics has not reviewed all of the sites linked to its website and is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by Art Aesthetics of the site. Use of any such linked website is at the user's own risk.</p>
        </section>

        <section>
          <h2>7. Modifications</h2>
          <p>Art Aesthetics may revise these terms of service for its website at any time without notice. By using this website, you are agreeing to be bound by the then current version of these terms of service.</p>
        </section>

        <section>
          <h2>8. Governing Law</h2>
          <p>These terms and conditions are governed by and construed in accordance with the laws of England and Wales, and you irrevocably submit to the exclusive jurisdiction of the courts located in that location.</p>
        </section>

        <section>
          <h2>9. Contact Information</h2>
          <p>If you have any questions about these Terms of Service, please contact us at:</p>
          <p>
            <strong>Art Aesthetics</strong><br />
            Hughes Close, Widnes<br />
            Cheshire, WA8 5EJ<br />
            <a href="mailto:info@artaestheticsskincare.com">info@artaestheticsskincare.com</a>
          </p>
        </section>
      </div>
    </div>
  );
};

export default TermsOfService;
